/* ========================================================================
 * Product questions form items
 * ======================================================================== */

import Toolbox from "./toolbox";

let options = false;
let initialised = false;

/**
 * Hide some answers based on answers.
 * 
 * @param {Node} element - Select element.
 */
function addAnswerListener(element) {
	element.addEventListener("change", (e) => {
		const select = e.target;

		if (select.dataset.skipOtherAnswers !== undefined) {

			if (select.dataset.skipOtherAnswers === select.value) {
				const questionsGroups = Toolbox.closest(select, ".questions-groups");
				if (questionsGroups) {
					const groupsToHide = questionsGroups.querySelectorAll(".form-group:not(.main-question)");
					for (const group of groupsToHide) {
						group.style.display = "none";
						group.dataset.hidingAnswer = "true";
						const requiredInputs = group.querySelectorAll('*[data-required="true"]');
						for (const requiredInput of requiredInputs) {
							requiredInput.required = false;
						}
					}
				}
			} else {
				const questionsGroups = Toolbox.closest(select, ".questions-groups");
				if (questionsGroups) {
					const groupsToShow = questionsGroups.querySelectorAll('*[data-hiding-answer="true"]');
					for (const group of groupsToShow) {
						group.style.display = "";
						group.dataset.hidingAnswer = "false";
						const requiredInputs = group.querySelectorAll('*[data-required="true"]');
						for (const requiredInput of requiredInputs) {
							requiredInput.required = true;
						}
					}
				}
			}
		}

	});
}

function init() {
	if (!initialised) {
		var questions = document.querySelector(".package-questions");
		if (questions) {
			options = questions;
			const mainQuestions = options.querySelectorAll(".main-question .component-select select");
			for (const mainQuestion of mainQuestions) {
				addAnswerListener(mainQuestion);
			}
		}

		initialised = true;
		return initialised;
	}
}

// populate additionalQuestionsObject
function getAnswers() {
	if (!options) {
		return undefined;
	}

	const additionalQuestions = options.querySelectorAll('.form-group:not([data-hiding-answer="true"]) input, select');
	var questionAnswersObject = {};
	/*
	var _reset = function () {
		var radioButtons = options.querySelectorAll('[type="radio"]');
		for (var i = 0; i < radioButtons.length; i++) {
			var radioButton = radioButtons[i];
			radioButton.checked = false;
			var radioComponent = Toolbox.closest(radioButton, ".component-radio");
			if (radioComponent) {
				radioComponent.classList.remove("checked");
			}
		}
	};*/

	for (const el of additionalQuestions) {

		if (el.type === "radio") {
			const domValue = document.querySelector(
				'[name="' + el.name + '"]:checked'
			);

			if (domValue) {
				questionAnswersObject[el.name] = Boolean(parseInt(domValue.value));
			}
		} else {
			questionAnswersObject[el.name] = el.value;
		}
	}

	//_reset();

	return questionAnswersObject;
}

function checkAnswers() {
	if (options) {
		const additionalQuestions = options.querySelectorAll('.form-group:not([data-hiding-answer="true"]) input, select');
		let valid = true;
		for (const additionalQuestion of additionalQuestions) {
			if (!additionalQuestion.checkValidity()) {
				valid = false;
				break;
			}

			if (additionalQuestion.dataset.placeHolder === "true" && additionalQuestion.value === "") {
				valid = false;
			}
		}

		return valid;

	} else {
		return true;
	}
}

export default {
	init: init,
	checkAnswers: checkAnswers,
	getAnswers: getAnswers
};
